module.exports = __webpack_public_path__ + "/bundle/asset/admission3-2-d8668fe7e371689d2bdc245d5d4d85c5.png";